import { render } from "./imgAppVPos.vue?vue&type=template&id=0a6c810d&scoped=true"
import script from "./imgAppVPos.vue?vue&type=script&lang=js"
export * from "./imgAppVPos.vue?vue&type=script&lang=js"

import "./imgAppVPos.vue?vue&type=style&index=0&id=0a6c810d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a6c810d"]])

export default __exports__